import { useSeo } from "@/hooks/useSeo";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuick from "@/pages/home/components/CategoryQuick";
import FeaturedGrid from "@/pages/home/components/FeaturedGrid";
import TopicCollections from "@/pages/home/components/TopicCollections";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  useSeo(
    "看片网站-丰富影视资源在线观看平台",
    "看片网站提供大量电影、电视剧资源，覆盖多种类型，方便用户在线观看影视视频，体验精彩内容。",
    "看片网站,影视资源,在线电影,电视剧播放,视频观看,影视平台,高清影视"
  );

  return (
    <>
      <HeroCarousel />
      <CategoryQuick />
      <FeaturedGrid />
      <TopicCollections />
      <SiteIntro />
    </>
  );
}